import { useCallback, useEffect, useState } from 'react';
import api from '../api/client.js';

/**
 * Application settings (organization names, print geometry, letterhead
 * presence). Loaded once after sign-in and refreshed when the server signals a
 * settings change.
 */
export function useSettings(enabled) {
  const [settings, setSettings] = useState(null);
  const [hasLetterhead, setHasLetterhead] = useState(false);
  // 'file' (installed letterhead.html) | 'upload' | 'none'
  const [letterheadSource, setLetterheadSource] = useState('none');

  const reload = useCallback(async () => {
    if (!enabled) return;
    try {
      const data = await api.getSettings();
      setSettings(data.settings);
      setHasLetterhead(data.hasLetterhead);
      setLetterheadSource(data.letterheadSource || 'none');
    } catch {
      // Non-fatal: the app falls back to built-in defaults for display, and the
      // print document uses its text header and footer.
    }
  }, [enabled]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    settings,
    hasLetterhead,
    letterheadSource,
    reloadSettings: reload,
    setSettings,
    setHasLetterhead,
    setLetterheadSource,
  };
}

export default useSettings;
